import { getSiteLocalization } from '@/lib/i18n/config/site-locales'

/**
 * formatPercentage(20, '-') => -20%
 * formatPercentage(20, '+') => 20%
 * formatPercentage(20, '-', 2) => -20.00%
 * formatPercentage(20, '+', 2) => 20.00%
 * formatPercentage(-20, '+') => 20%
 */
export const formatPercentage = (value: number, sign: '-' | '+', decimal: number = 0): string => {
  const formatted = new Intl.NumberFormat(getSiteLocalization().locale, {
    style: 'percent',
    minimumFractionDigits: decimal,
    maximumFractionDigits: decimal,
  }).format(Math.abs(value / 100) * (sign === '-' ? -1 : 1))

  // Remove any space (including non-breaking) before the '%' sign
  return formatted.replace(/\s*%$/, '%')
}
